import { FastField, FieldProps } from 'formik';
import { memo } from 'react';

import { FormControlTextInput } from '@fhs/ui';
import { IconCheck } from '@fhs/ui';
import { tokens } from '@fhs/ui';
import { useOrderContext } from '@fhs-legacy/frontend/src/state/order';
import { CHECKOUT_DELIVERY_PHONE_INPUT } from '@fhs-legacy/frontend/src/utils/test-ids';

export const MAX_PHONE_NUMBER_LENGTH = 13;

export function sanitizePhoneNumber(value: string) {
  return value.replace(/[^\d+]/g, '').slice(0, MAX_PHONE_NUMBER_LENGTH);
}

function PhoneNumberField() {
  const { setOrderPhoneNumber } = useOrderContext();

  return (
    <FastField
      name="phoneNumber"
      shouldUpdate={(nextProps, props) => {
        return (
          nextProps.formik.values.phoneNumber !== props.formik.values.phoneNumber ||
          nextProps.formik.errors.phoneNumber !== props.formik.errors.phoneNumber ||
          nextProps.formik.touched.phoneNumber !== props.formik.touched.phoneNumber
        );
      }}
    >
      {({ field, meta }: FieldProps) => {
        const handleBlur = (e: any) => {
          field.onBlur('phoneNumber')(e);
          setOrderPhoneNumber(sanitizePhoneNumber(field.value));
        };

        return (
          <FormControlTextInput
            testID={CHECKOUT_DELIVERY_PHONE_INPUT}
            label="Phone Number"
            placeholder="Enter your phone number"
            value={field.value}
            onChangeText={text => field.onChange('phoneNumber')(sanitizePhoneNumber(text))}
            onBlur={handleBlur}
            keyboardType="phone-pad"
            maxLength={MAX_PHONE_NUMBER_LENGTH}
            required
            rightIcon={
              !meta.error && field.value.length > 0 ? (
                <IconCheck size={20} color={tokens.colors.$success} />
              ) : undefined
            }
          />
        );
      }}
    </FastField>
  );
}

export default memo(PhoneNumberField);
